import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const categories = [
    { name: "Hampers", image: "/generated/main/category-1.jpg" },
    { name: "Picnic", image: "/generated/main/category-2.jpg" },
    { name: "Gift Boxes", image: "/generated/main/category-3.jpg" },
    { name: "Up to 20% off English Sparkling Wine", image: "/generated/main/category-4.jpg" },
    { name: "Thank You Teacher", image: "/generated/main/category-5.jpg" },
    { name: "Biscuits", image: "/generated/main/category-6.jpg" },
    { name: "Tea & Coffee", image: "/generated/main/category-7.jpg" },
    { name: "Chocolate", image: "/generated/main/category-8.jpg" },
    { name: "New In", image: "/generated/main/category-9.jpg" },
  ];

 

  const specialGifts = [
    { name: "Wedding", image: "/generated/main/content-5.jpg" },
    { name: "New In", image: "/generated/main/content-6.jpg" },
    { name: "Personalisation", image: "/generated/main/content-7.jpg" },
  ];

  const journalStories = [
    { 
      title: "In celebration of Pride, we're putting t...", 
      image: "/generated/main/content-8.jpg" 
    },
    { 
      title: "Our Open Call is back for 2026, and afte...", 
      image: "/generated/main/content-9.jpg" 
    },
    { 
      title: "The failblossom Edit highlights standout ...", 
      image: "/generated/main/content-10.jpg" 
    },
  ];

  return (
    <div className="main">
      <main>
        <section className="hero-section">
          <div className="hero-container">
            <div className="hero-card">
              <img src="/generated/main/content-1.jpg" alt="Midsummer at failblossom" />
              <div className="hero-overlay">
                <h2>Midsummer<br />at failblossom</h2>
                <Link to="/shop" onClick={toTop} className="hero-button">Shop Now</Link>
              </div>
            </div>
            <div className="hero-card">
              <img src="/generated/main/content-2.jpg" alt="The New Home of Biscuit Adventures" />
              <div className="hero-overlay">
                <h2>The New Home of<br />Biscuit Adventures</h2>
                <Link to="/shop" onClick={toTop} className="hero-button">Shop Biscuitorium</Link>
              </div>
            </div>
          </div>
        </section>

        <section className="categories-section">
          <h2 className="section-title">Say It With failblossom</h2>
          <div className="categories-grid">
            {categories.map((category, index) => (
              <Link to="/shop" key={index} className="category-card" onClick={toTop}>
                <div className="category-image">
                  <img src={category.image} alt={category.name} />
                </div>
                <p className="category-name">{category.name}</p>
              </Link>
            ))}
          </div>
        </section>

        <section className="products-section">
          <div className="products-header">
            <h2 className="section-title">Newly Bloomed at failblossom</h2>
            <p className="section-subtitle">Take your pick of thoughtful gifts and delicious treats, and discover the latest arrivals at failblossom.</p>
            <Link to="/shop" onClick={toTop} className="shop-button">Shop Newness</Link>
          </div>
          <div className="products-grid">
            {productData.slice(0,4).map((product, index) => (
              <Link to="/shop" key={index} className="product-card" onClick={toTop}>
                <div className="product-image">
                  <img src={`/generated/main/product-${index + 1}.jpg`} alt={product.name} />
                </div>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">{product.price}</p>
              </Link>
            ))}
          </div>
         
        </section>

        <section className="hamper-section">
          <div className="hamper-container">
            <div className="hamper-left">
              <h2>Create Your<br />Own Hamper</h2>
              <img src="/generated/main/content-3.jpg" alt="Create Your Own Hamper" />
              <p>You can add almost anything...</p>
              <Link to="/shop" onClick={toTop} className="hamper-button">Start Creating Your Hamper</Link>
            </div>
            <div className="hamper-right">
              <div className="hamper-grid">
                <img src="/generated/main/content-4.jpg" alt="Hamper packing details" />
                
              </div>
            </div>
          </div>
        </section>

        <section className="special-gifts-section">
          <h2 className="section-title">Special Gifts for Special Someones</h2>
          <div className="special-gifts-grid">
            {specialGifts.map((gift, index) => (
              <Link to="/shop" key={index} className="special-gift-card" onClick={toTop}>
                <img src={gift.image} alt={gift.name} />
                <div className="special-gift-overlay">
                  <h3>{gift.name}</h3>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <section className="journal-section">
          <div className="journal-header">
            <h2 className="journal-title">Stories</h2>
            <p className="journal-subtitle">FROM</p>
            <h3 className="journal-name">THE JOURNAL</h3>
          </div>
          <div className="journal-grid">
            {journalStories.map((story, index) => (
              <Link to="/about" key={index} className="journal-card" onClick={toTop}>
                <div className="journal-image">
                  <img src={story.image} alt={story.title} />
                </div>
                <div className="journal-content">
                  <p>{story.title}</p>
                  <span className="read-more">Read more +</span>
                </div>
              </Link>
            ))}
          </div>
          <div className="journal-cta">
            <Link to="/about" onClick={toTop} className="journal-button">View more Stories</Link>
          </div>
        </section>

         
      </main>
    </div>
  );
}

export default Main;
